<template>
  <video id="game_player" ref="gamePlayer" class="video-js vjs-fill"></video>
</template>

<script>
import videojs from "video.js";
import { mapState, mapGetters, mapActions } from "vuex";
import { setTimeout } from "timers";
import Vue from "vue";

export default {
  name: "GamePlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    clips: {
      type: Object,
      default() {
        return {};
      }
    },
    videoURL: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      VideoData: {}
    };
  },
  computed: {
    ...mapState({
      clip: state => state.clip,
      portal: state => state.portal,
      actionsBtns: state => state.actionsBtns.btnPressed,
      actionsResult: state => state.actionsBtns.result
    })
  },
  watch: {
    actionsBtns: {
      handler(val) {
        // console.log("Action video.js: " + JSON.stringify(val, null, 2));
        this[val]();
      },
      deep: true
    },
    videoURL() {
      // console.log("this.videoURL = " + this.videoURL)
      this.VideoData = this.videoURL;
    }
  },
  methods: {
    playerInitialise() {
      this.player = videojs(
        this.$refs.gamePlayer,
        this.options,
        function onPlayerReady() {
          // console.log("onPlayerReady", this);
        }
      );
    },
    convertSecToMS(sec) {
      var ms = parseInt(sec * 1000);
      sec = ms;
      return sec;
    },
    //play video from a certain moment
    playGameMoment() {
      var startMoment = this.actionsResult[0];
      var duration = this.actionsResult[1];
      duration = this.convertSecToMS(duration);
      // console.log(
      //   "Video start moment: " + startMoment + "\nVideo duration: " + duration
      // );
      this.player.currentTime(startMoment);
      if (this.player.paused()) {
        this.player.play();
      } else {
       // this.player.pause();
      }

      var v = this;
      //pause video when it reaches the end point
      setTimeout(function() {
        v.player.pause();
      }, duration);
    }
  },
  mounted() {
    this.playerInitialise();
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
};
</script>

<style>
</style>


